import React from 'react';

function QuizQuestion({ question, onAnswer }) {
    const answers = [];
    if (question.answer1) answers.push({ number: 1, text: question.answer1 });
    if (question.answer2) answers.push({ number: 2, text: question.answer2 });
    if (question.answer3) answers.push({ number: 3, text: question.answer3 });
    if (question.answer4) answers.push({ number: 4, text: question.answer4 });

    return (
        <div>
            <p className="quiz-question-text">{question.questionText}</p>
            {answers.map((answer) => (
                <button
                    key={answer.number}
                    className="quiz-answer-button"
                    onClick={() => onAnswer(question, answer.number)}
                >
                    {answer.text}
                </button>
            ))}
        </div>
    );
}

export default QuizQuestion;
